
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ChatMessage } from '@/modules/analysis/models/analysisRequest';
import * as AnalysisRequestService from '@/modules/analysis/services/analysisRequestService';

@Component({
  components: {}
})
export default class AboutChatMessage extends Vue {
  protected readonly MESSAGE_MAX_LENGTH = 50;
  @Prop({ required: true })
  protected requestId?: string;
  @Prop()
  protected chatMessages?: ChatMessage[];
  @State((state) => state.authentication.decodedJwtToken)
  protected decodedJwtToken?: { [key: string]: unknown };
  protected messageLoading = false;
  protected inputMessage = '';

  protected getFullMessage(message: ChatMessage): string {
    let messageDate = 'N/A';
    if (this.$options.filters) {
      messageDate = this.$options.filters.dateFormat(new Date(message.createdAt), 'DD/MM/YY HH:mm');
    }
    const messageActor = `${message.actor.givenName} ${message.actor.familyName}`;
    const params = { messageDate, messageActor, messageContent: message.content };
    const msg = this.$i18n.t('analysis.AboutMessage.chatMessage', params).toString();

    return msg;
  }

  protected onSubmit(): void {
    if (this.requestId && this.inputMessage.length > 0 && this.inputMessage.length <= this.MESSAGE_MAX_LENGTH) {
      this.messageLoading = true;
      AnalysisRequestService.createMessage(this.requestId, { content: this.inputMessage })
        .then(() => {
          this.$emit('refresh');
          this.inputMessage = '';
          (this.$refs.chatMessageContainer as HTMLElement).scrollTo(0, 0);
        })
        .finally(() => (this.messageLoading = false));
    }
  }

  protected isMyMessage(message: ChatMessage): boolean {
    return message.actor.id === this.decodedJwtToken?.sub;
  }
}
